// extracted by mini-css-extract-plugin
module.exports = {"section":"_404-content-module--section--3NXoa","canvas":"_404-content-module--canvas--2caN2"};